// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"e1c3d58a","488":"c9e09703"}[chunkId] + ".chunk.js";
};